
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("buzhH", function(module, exports) {
/* ExternalCollaboratorsSpaceInformationMessageBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6lvbX = parcelRequire("6lvbX");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8503df358cb92af5$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _2rkofajl _1reo15vq _18m915vq _bfhkysee",
            __cmplp.className
        ])
    });
});
const $8503df358cb92af5$export$572064d9f672f85d = (props)=>{
    const [shouldShowExternalCollaborators, setShouldShowExternalCollaborators] = (0, $42omo.useState)(false);
    const onExternalCollaborationLoadComplete = (props)=>{
        setShouldShowExternalCollaborators(props?.guestCount > 0);
    };
    const onExternalCollaborationLoadError = ()=>{
        setShouldShowExternalCollaborators(false);
    };
    const ParentWrapper = props?.wrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ParentWrapper, {
        hidden: !shouldShowExternalCollaborators
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8503df358cb92af5$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6lvbX.ExternalCollaboratorsSpaceInformationMessage), {
        ...props,
        onLoadComplete: onExternalCollaborationLoadComplete,
        onLoadError: onExternalCollaborationLoadError
    })));
};
module.exports["ExternalCollaboratorsSpaceInformationMessageBanner"] = $8503df358cb92af5$export$572064d9f672f85d;

});

parcelRegister("6lvbX", function(module, exports) {
/**
 * @generated SignedSource<<9af7ab75c6ab75b0ad24b0bb47ed8754>>
 * @relayHash 32a952014d67b0057adc7b01553cbb8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59aea14d53b9d666582c86e38ca652d828e911e876a43cf207a50c947919c769
const $a53bf567f7c11134$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalCollaboratorCount"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "32a952014d67b0057adc7b01553cbb8d",
            "id": "59aea14d53b9d666582c86e38ca652d828e911e876a43cf207a50c947919c769",
            "metadata": {},
            "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
            "operationKind": "query",
            "text": "query ExternalCollaboratorsSpaceInformationMessageQuery($spaceKey:String){space(key:$spaceKey){id,name,externalCollaboratorCount,currentUser{isAdmin}}}"
        }
    };
}();
$a53bf567f7c11134$var$node.hash = "930fa48aeb29519bd20c8cdd9958c15b";
var $a53bf567f7c11134$export$2e2bcd8739ae039 = $a53bf567f7c11134$var$node;



var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $a3fRD = parcelRequire("a3fRD");


var $eXmBZ = parcelRequire("eXmBZ");


var $6xdDU = parcelRequire("6xdDU");


var $jMyy4 = parcelRequire("jMyy4");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7QM6o = parcelRequire("7QM6o");


var $cLo2u = parcelRequire("cLo2u");


var $jmjWc = parcelRequire("jmjWc");


const $8d0dcdd220890645$export$9a1f6434985b7141 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2jSJc",
    name: "ViewSpaceExternalCollaboratorsDialogLoadable",
    loader: async ()=>(await (parcelRequire("2EBCF"))).ViewSpaceExternalCollaboratorsDialog
});


const $e305cd57fd097c2e$var$ExternalCollaboratorsSpaceInformationMessageQuery = (0, $a53bf567f7c11134$export$2e2bcd8739ae039);
const $e305cd57fd097c2e$var$i18n = (0, $aXWIB.defineMessages)({
    spaceNavigationMessageLink: {
        id: "space-guest-list.external-collaborator-message.navigation.guests-access-to-space",
        defaultMessage: "{guestCallToAction} in this space"
    },
    spaceMessageLink: {
        id: "space-guest-list.external-collaborator-message.space.guests-access-to-space",
        defaultMessage: "{guestCallToAction} {guestCount, plural, one {has} other {have}} access to this space."
    },
    pageMessageLink: {
        id: "space-guest-list.external-collaborator-message.page.guests-access-to-page",
        defaultMessage: "{guestCallToAction} can access."
    },
    pageMessageLinkWithSeparateCallToAction: {
        id: "space-guest-list.external-collaborator-message.page.guests-access-to-page-cta",
        defaultMessage: "{guests} can access. {callToAction}"
    },
    additionalContextMessage: {
        id: "space-guest-list.external-collaborator-message.guest-context",
        defaultMessage: "Guests are external to your organization."
    },
    guestCallToActionMessage: {
        id: "space-guest-list.external-collaborator-message.guest-count",
        defaultMessage: "{guestCount, plural, =0 {No guests} one {# guest} other {# guests}}"
    },
    callToActionMessage: {
        id: "space-guest-list.external-collaborator-message.view-guest-action",
        defaultMessage: "{guestCount, plural, one {View guest} other {View guests}}"
    },
    errorMessage: {
        id: "space-guest-list.external-collaborator-message.error",
        defaultMessage: "An error occurred while retrieving guests."
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e305cd57fd097c2e$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulppxbi _1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e305cd57fd097c2e$var$IconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e305cd57fd097c2e$var$MessageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSubtlest: isSubtlest, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw",
            __cmplp.isSubtlest ? "_syaz1rpy" : "_syazazsu",
            __cmplp.className
        ])
    });
});
const $e305cd57fd097c2e$var$MessageButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSubtlest: isSubtlest, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19zy1r31 _5fak8stv _q1zanqa1 _13gm1r31 _gms98stv _1ddtnqa1 _143jazsu",
            __cmplp.isSubtlest ? "_8avf1rpy" : "_8avfazsu",
            __cmplp.className
        ])
    });
});
const $e305cd57fd097c2e$var$NullButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.className
        ])
    });
});
const $e305cd57fd097c2e$var$MessageSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2rko12b0 _1e0c1txw _bfhki8nm",
            __cmplp.className
        ])
    });
});
var $e305cd57fd097c2e$export$d804669af4df8a67 = /*#__PURE__*/ function(ExternalCollaboratorsSpaceInformationMessageType) {
    ExternalCollaboratorsSpaceInformationMessageType["IN_SPACE"] = "IN_SPACE";
    ExternalCollaboratorsSpaceInformationMessageType["ACCESS_TO_SPACE"] = "ACCESS_TO_SPACE";
    ExternalCollaboratorsSpaceInformationMessageType["ACCESS_TO_PAGE"] = "ACCESS_TO_PAGE";
    ExternalCollaboratorsSpaceInformationMessageType["ACCESS_TO_PAGE_CTA"] = "ACCESS_TO_PAGE_CTA";
    return ExternalCollaboratorsSpaceInformationMessageType;
}({});
const $e305cd57fd097c2e$var$PRIMARY_MESSAGE = {
    ["IN_SPACE"]: $e305cd57fd097c2e$var$i18n.spaceNavigationMessageLink,
    ["ACCESS_TO_SPACE"]: $e305cd57fd097c2e$var$i18n.spaceMessageLink,
    ["ACCESS_TO_PAGE"]: $e305cd57fd097c2e$var$i18n.pageMessageLink,
    ["ACCESS_TO_PAGE_CTA"]: $e305cd57fd097c2e$var$i18n.pageMessageLinkWithSeparateCallToAction
};
const $e305cd57fd097c2e$var$getPrimaryMessage = (messageType)=>{
    return $e305cd57fd097c2e$var$PRIMARY_MESSAGE[messageType] ?? $e305cd57fd097c2e$var$i18n.spaceMessageLink;
};
const $e305cd57fd097c2e$var$ANALYTICS_SOURCE_MODAL_DIALOG = 'viewExternalCollaboratorsModalDialog';
const $e305cd57fd097c2e$export$cbb9594d20a6fe04 = ({ analyticsSource: analyticsSource, messageType: messageType, shouldShowMessageIcon: shouldShowMessageIcon, shouldShowAdditionalMessageContext: shouldShowAdditionalMessageContext, spaceKey: propSpaceKey, onLoadComplete: onLoadComplete, onLoadError: onLoadError, isSubtle: isSubtle, dontRecolorGuestCount: dontRecolorGuestCount })=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)(propSpaceKey);
    const spaceId = (0, $7QM6o.useSpaceId)(propSpaceKey);
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const isSubtlest = !!isSubtle;
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($e305cd57fd097c2e$var$ExternalCollaboratorsSpaceInformationMessageQuery, {
        variables: {
            spaceKey: spaceKey
        }
    });
    const guestCount = data?.space?.externalCollaboratorCount ?? 0;
    (0, $42omo.useEffect)(()=>{
        if (error) onLoadError?.(error);
    }, [
        error,
        onLoadError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading) onLoadComplete?.({
            guestCount: guestCount
        });
    }, [
        guestCount,
        loading,
        onLoadComplete
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onButtonClick = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'viewGuestsList',
                source: analyticsSource,
                containerType: 'space',
                containerId: spaceId
            }
        }).fire();
        setIsModalOpen(true);
    }, [
        createAnalyticsEvent,
        spaceId,
        analyticsSource
    ]);
    const onClose = ()=>{
        setIsModalOpen(false);
    };
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).EXTERNAL_COLLAB
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$IconWrapper, {
        hidden: !shouldShowMessageIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$MessageWrapper, {
        isSubtlest: isSubtlest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e305cd57fd097c2e$var$i18n.errorMessage)))));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$MessageSkeleton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)));
    const CtaComponent = dontRecolorGuestCount ? $e305cd57fd097c2e$var$NullButtonWrapper : $e305cd57fd097c2e$var$MessageButtonWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$Wrapper, null, shouldShowMessageIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        spacing: "spacious",
        color: "var(--ds-icon-information, #357DE8)",
        label: "info"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$MessageWrapper, {
        isSubtlest: isSubtlest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$e305cd57fd097c2e$var$getPrimaryMessage(messageType),
        values: {
            guestCount: guestCount,
            guests: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$e305cd57fd097c2e$var$i18n.guestCallToActionMessage,
                values: {
                    guestCount: guestCount
                }
            }),
            guestCallToAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CtaComponent, {
                "data-testid": "view-external-collaborators-link",
                isSubtlest: isSubtlest
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                spacing: "none",
                onClick: onButtonClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$e305cd57fd097c2e$var$i18n.guestCallToActionMessage,
                values: {
                    guestCount: guestCount
                }
            }))),
            callToAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                spacing: "none",
                onClick: onButtonClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$e305cd57fd097c2e$var$i18n.callToActionMessage,
                values: {
                    guestCount: guestCount
                }
            }))
        }
    }), shouldShowAdditionalMessageContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e305cd57fd097c2e$var$i18n.additionalContextMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d0dcdd220890645$export$9a1f6434985b7141), {
        spaceKey: spaceKey || '',
        hasHeaderImage: false,
        onClose: onClose,
        onCloseComplete: ()=>{},
        analyticsSource: $e305cd57fd097c2e$var$ANALYTICS_SOURCE_MODAL_DIALOG,
        clickSource: analyticsSource
    })));
};
module.exports["ExternalCollaboratorsSpaceInformationMessageType"] = $e305cd57fd097c2e$export$d804669af4df8a67;
module.exports["ExternalCollaboratorsSpaceInformationMessage"] = $e305cd57fd097c2e$export$cbb9594d20a6fe04;

});

parcelRegister("2EBCF", function(module, exports) {

let $1eec8044ee52081d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1eec8044ee52081d$var$load("hhss7"),
    $1eec8044ee52081d$var$load("l5XQ1")
]).then(()=>parcelRequire('l9IRD'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});


//# sourceMappingURL=MovePageDialog.9a7cff7e.js.map
